// SalesStatisticsController.ts
import axios from "axios";
import BaseController from "./BaseController";

export interface SalesThemeModel {
  id: string;
  name: string;
  productType: string;
  blockType: string;
  categoryId: string;
  categoryName: string;
  licenseId: string;
  licenseName: string;
  totalCount: number;
  totalSum: number;
  previewUrl: string;
}

export interface SalesCategoryModel {
  categoryId: string;
  categoryName: string;
  licenseId: string;
  licenseName: string;
  blockType: string;
  blockCount: number;
  previewUrl: string;
  totalCount: number;
  releaseDate: Date;
  expireDate: Date;
  themes: SalesThemeModel[];
}

export interface SalesThemeDetailModel {
  salesId: string;
  vendingMachineId: string;
  vendingMachineName: string;
  groupName: string;
  blockId: string;
  blockName: string;
  subjectName: string;
  blockType: string;
  categoryId: string;
  categoryName: string;
  licenseId: string;
  licenseName: string;
  previewUrl: string;
  setIndex: number;
  setProductType: string;
  setCount: number;
  setPrice: number;
  salesPrice: number;
  salesOriginPrice: number;
  salesDiscountablePrice: number;
  salesCount: number;
  salesCouponKey: string;
  createTime: string;
}

export interface SalesStatisticsParams {
  startDate: string;
  endDate: string;
  licenseId?: string;
  locale?: string;
  modeId?: string;
}

export default class SalesStatisticsController extends BaseController {
  constructor(hostUrl: string, apiKey: string) {
    super(hostUrl, apiKey);
  }

  public async getSalesThemesAsync(params: SalesStatisticsParams): Promise<SalesCategoryModel[]> {
    const response = await axios.get<SalesCategoryModel[]>(
      `${this.hostUrl}/api/v1/sales/themes`,
      {
        headers: {
          "x-functions-key": this.apiKey,
          "content-type": "application/json",
        },
        withCredentials: true,
        params: {
          startDate: params.startDate,
          endDate: params.endDate,
          ...(params.licenseId !== "" && { licenseId: params.licenseId }),
          ...(params.locale && { locale: params.locale }),
          ...(params.modeId && { modeId: params.modeId }),
        },
      }
    );
    return response.data;
  }

  public async getSalesThemesDetailAsync(params: SalesStatisticsParams): Promise<SalesThemeDetailModel[]> {
    const response = await axios.get<{ themes: SalesThemeDetailModel[] }>(
      `${this.hostUrl}/api/v1/sales/themes/detail`,
      {
        headers: {
          "x-functions-key": this.apiKey,
          "content-type": "application/json",
        },
        withCredentials: true,
        params: {
          startDate: params.startDate,
          endDate: params.endDate,
          ...(params.licenseId !== "" && { licenseId: params.licenseId }),
          ...(params.locale && { locale: params.locale }),
          ...(params.modeId && { modeId: params.modeId }),
        },
      }
    );
    return response.data.themes;
  }
}